export default __webpack_public_path__ + "static/media/TimeCircle.d148a30f.svg";